import {
  Menu,
  MenuItem,
  MenuList,
  Divider,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useImperativeHandle, useState } from "react";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { useNavigate } from "react-router";
import {
  IconUser,
  IconBuilding,
  IconWallet,
  IconCertificate,
  IconFileText,
  IconAward,
} from "@tabler/icons-react";
import {
  dataKeyApplicationAthleteDetails,
  dataKeyApplicationClubDetails,
  dataKeyApplicationOfficialDetails,
  dataKeyOfficialDetails,
  dataKeyTransactionHeaders,
  redirectTo,
} from "src/qubCommon/helperMethods/redirectionHelper";
import { OpenInNew } from "@mui/icons-material";

const ExplorerContextMenu = (props) => {
  const { contextMenu, navUrl = "", extraNavs = [], contextMenuIds } = props;
  const [menu, setMenu] = useState(null);
  useImperativeHandle(contextMenu?.contextMenuRef, () => ({
    open: setMenu,
  }), []);
  const handleClose = () => setMenu(null);
  const menuIds = menu?.ids ?? contextMenuIds;

  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleOpenInNewTab = () => {
    const newWindow = window.open(
      navUrl.replace("{:id}", menu?.navigationId),
      "_blank"
    );
    newWindow.focus();
    handleClose();
  };

  const handleCopyRow = () => {
    navigator.clipboard.writeText(
      Object.entries(menu?.data ?? {})
        .map((item) => `${item[1]}`)
        .join("\t ")
    );
    handleClose();
  };

  const handleCopyItem = () => {
    navigator.clipboard.writeText(menu?.cellData);
    handleClose();
  };
  const handleCopyAll = () => {
    navigator.clipboard.writeText(menu?.getAllData());
    handleClose();
  };

  const handleNavigate = (path) => {
    window.open(path, "_blank");
    handleClose();
  };
  const handleApplicationNavigate = (id, options) => {
    console.log("handleApplicationNavigate");
  };
  return (
    <Menu
      anchorReference="anchorPosition"
      anchorPosition={menu?.position}
      open={Boolean(menu)}
      onClose={handleClose}
    >
      {navUrl !== "" && (
        <MenuItem onClick={handleOpenInNewTab}>
          {" "}
          <ListItemIcon>
            <OpenInNew fontSize="small" />
          </ListItemIcon>
          <ListItemText> Άνοιγμα σε Νέα Καρτέλα</ListItemText>
        </MenuItem>
      )}
      <MenuList>
        {menuIds?.applicationId && (
          <MenuItem
            onClick={() =>
              handleApplicationNavigate(
                menuIds?.applicationId,
                menuIds?.applicationRenderOptions
              )
            }
          >
            <ListItemIcon>
              <IconFileText fontSize="small" />
            </ListItemIcon>
            <ListItemText> {t("ApplicationDetails")}</ListItemText>
          </MenuItem>
        )}

        <Divider />
      </MenuList>

      {extraNavs && extraNavs.length > 0 && (
        <MenuList>
          <Divider />
          {extraNavs.map((extraNav) => (
            <MenuItem
              key={`${extraNav.label}-${extraNav.path}`}
              onClick={() => handleNavigate(extraNav.path)}
            >
              <ListItemIcon>
                <OpenInNew fontSize="small" />
              </ListItemIcon>
              <ListItemText>{extraNav.label}</ListItemText>
            </MenuItem>
          ))}
          <Divider />
        </MenuList>
      )}
      <MenuItem onClick={handleCopyRow}>
        <ListItemIcon>
          <ContentCopy fontSize="small" />
        </ListItemIcon>
        <ListItemText> {t("CopyRow")}</ListItemText>
      </MenuItem>
      {menu?.cellData && (
        <MenuItem onClick={handleCopyItem}>
          <ListItemIcon>
            <ContentCopy fontSize="small" />
          </ListItemIcon>
          <ListItemText>Αντιγραφή Κελιού</ListItemText>
        </MenuItem>
      )}
      {menu?.getAllData && (
        <MenuItem onClick={handleCopyAll}>
          <ListItemIcon>
            <ContentCopy fontSize="small" />
          </ListItemIcon>
          <ListItemText>Αντιγραφή Όλων</ListItemText>
        </MenuItem>
      )}
    </Menu>
  );
};

export default ExplorerContextMenu;
